import React from 'react';
// custom imports
import '../../assets/css/Dashboard.css';
import TopBar from './TopBar/TopBar';
import TicTacToe from './tictactoe/TicTacToe';
import TicTacToeP2 from './tictactoe/TicTacToeP2';
import { sendInvite, checkInvite, acceptInvite, setSnakeScore, getSnakeScore } from './tictactoe/Methods';
// 3rd party imports
import { ReloadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Input, Button, Modal, message } from 'antd';
import Snake from 'react-simple-snake';
const Dashboard = () => {
    const [ticModal, setTicModal] = React.useState(false);
    const [acceptModal, setAcceptModal] = React.useState(false);
    const [startGameP1, setStartGameP1] = React.useState(false);
    const [startGameP2, setStartGameP2] = React.useState(false);
    const [snakeGame, setSnakeGame] = React.useState(false);
    const [ShareLoadingFlag, setShareLoadingFlag] = React.useState(false);
    const [score, setScore] = React.useState(0);
    const userName = React.useRef('');
    const scanInvite = async () => {
        const response = await checkInvite();
        if (response) {
            console.log("check");
            console.log(response);
            setAcceptModal(true);
        }
        else {
            message.info("No Invitation Yet");
        }
    };
    const snakeScoreGet = async () => {
        let sc = await getSnakeScore();
        setScore(sc);
    };
    React.useEffect(() => {
        scanInvite();
        snakeScoreGet();
    }, []);
    const handleInvite = async () => {
        setShareLoadingFlag(true);
        const response = await sendInvite(userName.current.state.value);
        if (response) {
            setTicModal(false);
            setStartGameP1(true);
            message.success('Invitation Sent');
        }
        else {
            message.error('Something Went Wrong! Check User Name');
        }
        setShareLoadingFlag(false);
    };
    const acceptTheInvite = async () => {
        setShareLoadingFlag(true);
        const response = await acceptInvite();
        if (response) {
            setAcceptModal(false);
            setTicModal(false);
            setStartGameP2(true);
            //message.success('Invitation Sent');
        }
        else {
            message.error('Something Went Wrong! Check User Name');
        }
        setShareLoadingFlag(false);
    };
    const cancelAcceptance = () => {
        setAcceptModal(false);
    };
    const snakeGameOff = () => {
        setSnakeScore(parseInt(localStorage.getItem("snakeHighScore")));
        if (parseInt(localStorage.getItem("snakeHighScore")) > Number(score)) {
            setScore(parseInt(localStorage.getItem("snakeHighScore")));
        }
        setSnakeGame(false);
    };
    return (React.createElement("div", { className: "dashboard-div" },
        React.createElement(TopBar, null),
        snakeGame ?
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement(ArrowLeftOutlined, { onClick: () => snakeGameOff(), style: { marginLeft: "2vw", color: "#000", fontSize: "22.5px", fontWeight: "600" } })),
                React.createElement("div", { style: { marginLeft: "2vw" } },
                    "Highest Score in Community:\u00A0\u00A0",
                    Number(score)),
                React.createElement(Snake, null))
            :
                startGameP1 ?
                    React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement(ArrowLeftOutlined, { onClick: () => setStartGameP1(false), style: { marginLeft: "2vw", color: "#000", fontSize: "22.5px", fontWeight: "600" } })),
                        React.createElement(TicTacToe, null))
                    :
                        startGameP2 ?
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement(ArrowLeftOutlined, { onClick: () => setStartGameP2(false), style: { marginLeft: "2vw", color: "#000", fontSize: "22.5px", fontWeight: "600" } })),
                                React.createElement(TicTacToeP2, null))
                            :
                                React.createElement("div", null,
                                    React.createElement("div", { className: "dash-top" },
                                        React.createElement("div", { style: { marginLeft: "40px" } },
                                            React.createElement("strong", null, "userName:"),
                                            "\u00A0\u00A0",
                                            localStorage.getItem("userName")),
                                        React.createElement("div", { style: { marginRight: "40px" } },
                                            "Scan For Invite\u00A0",
                                            React.createElement(ReloadOutlined, { onClick: () => scanInvite(), style: { marginRight: "2vw", color: "#000", fontSize: "22.5px", fontWeight: "600" } }))),
                                    React.createElement("div", { className: "game-section" },
                                        React.createElement("div", { onClick: () => { setTicModal(true); }, className: "game-block" },
                                            React.createElement("div", { id: "game-icon" },
                                                React.createElement("img", { src: "./icons/tictactoe.png", width: "60px" })),
                                            React.createElement("div", { id: "text-part" }, "Tic-Tac-Toe")),
                                        React.createElement("div", { onClick: () => { setSnakeGame(true); }, className: "game-block" },
                                            React.createElement("div", { id: "game-icon" },
                                                React.createElement("img", { src: "./icons/snake.png", width: "60px" })),
                                            React.createElement("div", { id: "text-part" }, "Snake")))),
        React.createElement(Modal, { visible: ticModal, onCancel: () => setTicModal(false), footer: null, title: null }, React.createElement("div", null,
            React.createElement("span", null,
                "User Name:\u00A0",
                React.createElement(Input, { ref: userName })),
            React.createElement(Button, { type: "primary", style: { float: 'right', marginTop: '10px' }, loading: ShareLoadingFlag, onClick: () => handleInvite() }, "Invite"),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null))),
        React.createElement(Modal, { visible: acceptModal, onCancel: () => cancelAcceptance(), footer: null, title: null },
            React.createElement(Button, { type: "primary", style: { float: 'right', marginTop: '10px' }, loading: ShareLoadingFlag, onClick: () => acceptTheInvite() }, "Accept Invite"),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null))));
};
export default Dashboard;
